import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import JsonCodeEditor from './JsonCodeEditor';
import { IsLoginContext, useIsLoginState } from '../login/IsLoginContext'
import { validateToken } from '../login/ValidateToken';
import { useNavigate } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const GET_APPHOME_URL = process.env.REACT_APP_GET_APPHOME_URL;

const Main = () => {
  const navigate = useNavigate();
  const [initialCode, setInitialCode] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { setIsLogin } = useContext(IsLoginContext);
  const isLogin = useIsLoginState();

  useEffect(() => {
    const fetchInitialData = async () => {
        const accessToken = localStorage.getItem('access_token');
        const tvresult = await validateToken(accessToken);
        if (!tvresult) {
          navigate("/unauthorized")
        }
      try {
        const response = await axios.get(`${GET_APPHOME_URL}`);
        let formattedData = JSON.stringify(response.data, null, 2);
        setInitialCode(formattedData);
      } catch (error) {
        console.error('Error fetching initial data:', error);
        setError('Failed to load initial data. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchInitialData();
  }, []);

    const handleUpdate = async (updatedCode) => {
        const accessToken = localStorage.getItem('access_token');
        const tvresult = await validateToken(accessToken);
        if (!tvresult) {
          navigate("/unauthorized")
        }
        try {
            // App Home Template & JSON 포맷 유효성 검사
            if (!updatedCode.includes("\"type\": \"home\"")) {
                throw new Error(`"type": "home"을 포함해주세요.`);
            }
            const parsedCode = JSON.parse(updatedCode);
            const formData = new FormData();
            formData.append("app_home_string", updatedCode);
            await axios.post(`${API_BASE_URL}/app-home`, parsedCode, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            transformRequest: [
            function () {
                return formData;
            },
            ],
        });
        return { success: true, message: 'Update successful!' };
        } catch (error) {
        console.error('Error updating:', error);
        return {
            success: false,
            message: 'Update failed. Please try again.',
            error: error.response ? error.response.data : error.message
        };
        }
  };

  if (isLoading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;
  }

  if (error) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: 'red' }}>{error}</div>;
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '12px',
      backgroundColor: '#f3f4f6',
    }}>
      <h1 style={{ marginBottom: '20px', color: '#1f2937' }}>App Home Editor</h1>
      <JsonCodeEditor initialCode={initialCode} onUpdate={handleUpdate} />
    </div>
  );
};

export default Main;